const deploymentPrivacyValues = {
  NONE: "NONE",
  TOTAL: "TOTAL",
  PARTIAL: "PARTIAL",
};

const isPrivacyActivated = privacy => privacy?.toUpperCase() !== deploymentPrivacyValues.NONE;

export default isPrivacyActivated;
